export interface IListOptionsFilter {
  forceNoPaging: boolean;
  page?: number;
  pageSize?: number;
  showDeactivated?: boolean;
}

export const defaultListOptionsFilter = {
  forceNoPaging: false,
  page: 0,
  pageSize: 10
}
